export const isHeicFile = async (attachment: Blob) => {
  const arrayBuffer = await attachment.slice(0, 12).arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);

  return (
    bytes[4] === 0x66 &&
    bytes[5] === 0x74 &&
    bytes[6] === 0x79 &&
    bytes[7] === 0x70 &&
    ((bytes[8] === 0x68 && bytes[9] === 0x65 && bytes[10] === 0x69 && bytes[11] === 0x63) ||
      (bytes[8] === 0x6d && bytes[9] === 0x69 && bytes[10] === 0x66 && bytes[11] === 0x31))
  );
};
